module.exports = __webpack_public_path__ + "2dbde4854993ef0f1f1ab4813d48871b.svg";